import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import RoleBaseRender from 'common/RoleBaseRender/RoleBaseRender';
import { Roles } from 'globals/enums';
import { residentSubPages } from 'globals/global.constants';
import { changeDocumentTitle } from 'globals/global.functions';
import SeniorLocation from 'pages/WCPages/SeniorLocation/SeniorLocation.component';
import SeniorWellnessPlan from 'pages/WCPages/SeniorWellnessPlan';
import WellnessDashboard from 'pages/WCPages/WellnessDashboard/WellnessDashboard.component';
import { WCThemeProvider } from 'themes';
import React from 'react';
import { useParams } from 'react-router-dom';
import SeniorCallLogs from 'pages/WCPages/SeniorCallLogs';
var ResidentSubPages = function () {
    var subRoute = useParams().subRoute;
    var changeTitle = React.useCallback(function (title) {
        setTimeout(function () {
            changeDocumentTitle(title);
        }, 360);
    }, []);
    switch (subRoute) {
        case residentSubPages.wellnessPlan.path:
            changeTitle(residentSubPages.wellnessPlan.title);
            return (_jsx(RoleBaseRender, { forRole: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices], children: _jsx(Box, { marginTop: '30px', children: _jsx(WCThemeProvider, { children: _jsx(SeniorWellnessPlan, { readOnly: true }) }) }) }));
        case residentSubPages.seniorCallLogs.path:
            changeTitle(residentSubPages.seniorCallLogs.title);
            return (_jsx(RoleBaseRender, { forRole: [
                    Roles.Admin,
                    Roles.FACILITY_AGENT,
                    Roles.Admin_WellnessServices,
                ], children: _jsx(Box, { marginTop: '30px', children: _jsx(WCThemeProvider, { children: _jsx(SeniorCallLogs, { readonly: true }) }) }) }));
        case residentSubPages.wellnessData.path:
            changeTitle(residentSubPages.wellnessData.title);
            return (_jsx(RoleBaseRender, { forRole: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices], children: _jsx(Box, { marginTop: '30px', children: _jsx(WellnessDashboard, {}) }) }));
        case residentSubPages.location.path:
            changeTitle(residentSubPages.location.title);
            return (_jsx(RoleBaseRender, { forRole: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices], children: _jsx(Box, { marginTop: '30px', children: _jsx(SeniorLocation, {}) }) }));
        default:
            return _jsx(_Fragment, {});
    }
};
export default ResidentSubPages;
